export default __webpack_public_path__ + "static/media/text_box-512.feb68117.png";